










































































import { Input, Form, FormItem, Select, Option, OptionGroup } from 'element-ui'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import CustomInput from '@/components/CustomInput.vue'
import CustomSelect from '@/components/CustomSelect.vue'
import InputWithSelect from '@/components/InputWithSelect.vue'

import EmergencyContact from '@/models/emegrency-contact'

import { ProfileDataActionTypes } from '@/store/modules/profileData'

@Component({
  components: {
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    CustomInput,
    CustomSelect,
    InputWithSelect,
  },
})
export default class EmergencyContactDetailsForm extends Vue {
  @Prop() emergencyContact!: EmergencyContact

  rules = {}

  form = {
    firstName: '',
    lastName: '',
    tel: '',
    countryCode: '',
    relationship: '',
  }

  @Watch('form', { deep: true })
  onFormChange(newVal: EmergencyContact) {
    this.$emit('input', newVal)
  }

  created() {
    this.$store.dispatch(ProfileDataActionTypes.LoadCountries)

    if (this.emergencyContact) {
      this.fillInForm()
    }
  }

  get countryOptions() {
    return this.$store.getters.countries
  }

  fillInForm() {
    const { form, emergencyContact, $_ } = this
    const prefilledFields = $_.pick(
      emergencyContact,
      Object.keys(form),
    ) as EmergencyContact

    this.form = { ...form, ...prefilledFields }
  }

  onEmergencyContactUpdate(updates: { [field: string]: any }) {
    this.$emit('on-emergency-contact-update', {
      emergencyContact: updates,
    })
  }

  // Public method for the parent component
  validate(): Promise<void> {
    return new Promise((resolve, reject) => {
      const formRef: any = this.$refs.ruleForm
      if (!formRef || typeof formRef.validate !== 'function') {
        return resolve()
      }

      formRef.validate((valid: boolean, fields?: any) => {
        if (!valid) {
          return reject(fields || new Error('Validation failed'))
        }
        resolve()
      })
    })
  }
}
